import React from 'react';
import { useUpdateVideo } from '../../hooks/useAppResources';
import {
    Box,
    Typography,
    FormControl,
    Button,
    TextField
} from "@mui/material";

function VideoUrlManager({item, style}){
    const updateVideo = useUpdateVideo();
    const [vidUrl, setVidUrl] = React.useState(item.vidUrl);

    let newVid ={
        Id: item.id,
        VidUrl: vidUrl,
        VidCategory: item.vidCategory,
        VidDescription: item.vidDescription,
        VidOrder: item.vidOrder,
        VidName: item.vidName,
        VidRoles: item.vidRoles,
    }

    function submitNotes(){
        updateVideo.mutate(newVid);

        setVidUrl();
    };

    return(
        <Box sx={style} style={{display: 'flex', justifyContent: 'space-between', justifyContent:'center' }}>
            <Box style={{flex:1, width:'100%'}}>
            <Typography id="modal-modal-title" variant="h5" component="h2" style={{textAlign:'center'}}>
                Video Url
            </Typography>
            <div style={{display:'flex', flexDirection:'column', width:'100%',}}>
                <FormControl sx={{ m: 2 }} style={{}}>
                    <TextField multiline rows={10} value={vidUrl} onChange={(event)=>setVidUrl(event.target.value)}></TextField>
                </FormControl>
                <Button onClick={() => submitNotes()}>Update Video Url</Button>
            </div>
            </Box>
        </Box>
    )
};

export default VideoUrlManager;